import classNames from 'classnames';
import {
  secondsInDay,
  secondsInHour,
  secondsInMinute,
  secondsInMonth,
  secondsInWeek,
  secondsInYear,
} from 'date-fns/constants';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: classNames.ArgumentArray) => {
  return twMerge(classNames(inputs));
};

export const formatAmount = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    useGrouping: true,
    // eslint-disable-next-line
    //@ts-ignore
    roundingMode: 'trunc',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatReward = (amount: number, options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    useGrouping: true,
    // eslint-disable-next-line
    //@ts-ignore
    roundingMode: 'trunc',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  }).format(amount);
};

export const truncateDecimalsOverThousand = (
  amount: number,
  options?: Intl.NumberFormatOptions,
) => {
  const isOverOrEqualThousand = amount >= 1000;

  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: isOverOrEqualThousand ? 0 : 2,
    maximumFractionDigits: isOverOrEqualThousand ? 0 : 2,
    // eslint-disable-next-line
    // @ts-ignore
    roundingMode: 'trunc',
    ...options,
  }).format(amount);
};

export const formatUsd = (usdAmount: number) => {
  let fractionDigits: number;

  if (usdAmount >= 0.01) {
    fractionDigits = 2;
  } else if (usdAmount >= 0.001) {
    fractionDigits = 3;
  } else if (usdAmount >= 0.0001) {
    fractionDigits = 4;
  } else {
    return `$${usdAmount}`;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    useGrouping: true,
    // eslint-disable-next-line
    //@ts-ignore
    roundingMode: 'trunc',
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  }).format(usdAmount);
};

export const formatAmountCompact = (amount: number) => {
  return Intl.NumberFormat('en-US', { notation: 'compact' }).format(amount);
};

export const formatTimeAgo = (date: Date): string => {
  const ranges = [
    ['years', secondsInYear],
    ['months', secondsInMonth],
    ['weeks', secondsInWeek],
    ['days', secondsInDay],
    ['hours', secondsInHour],
    ['minutes', secondsInMinute],
    ['seconds', 1],
  ] as const;

  const secondsElapsed = (date.getTime() - Date.now()) / 1000;

  const [rangeUnit, rangeSeconds] =
    ranges.find(([, seconds]) => Math.abs(secondsElapsed) > seconds) || ranges[ranges.length - 1];

  const delta = secondsElapsed / rangeSeconds;

  return new Intl.RelativeTimeFormat('en').format(Math.round(delta), rangeUnit);
};
